<h3 mat-dialog-title>Seçili Mesailer Reddedilecektir,</h3>
<div mat-dialog-content>
    <p>Emin misiniz?</p>
</div>
<div mat-dialog-content>
    <mat-select placeholder="Neden giriniz..." [(value)]="selectedRejectReason"
                style="margin-bottom: 20px;font-size: 11px;width: 120px;">
        <mat-option *ngFor="let rejectReason of rejectReasons" [value]="rejectReason">
            {{rejectReason.lookupValue}}
        </mat-option>
    </mat-select>

    <textarea *ngIf="selectedRejectReason.lookupValue === 'Diğer'" [(ngModel)]="rejectDescription"
              style="height: 150px;resize: none;width: 300px;margin-bottom: 10px;
              font-size: 11px;border: 1px solid #9c9c9c;padding: 4px;border-radius: 3px;"
              matInput id="description" aria-describedby="description" placeholder="Açıklama"></textarea>

</div>
<div mat-dialog-actions align="end">
    <button mat-button (click)="rejectSelected()">Evet</button>
    <button mat-button [mat-dialog-close]="data" cdkFocusInitial>Kapat</button>
</div>
